import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const steps = [
  "退職者の確認",
  "請求者の確認",
  "請求者情報の登録",
  "振込先金融機関の登録",
  "本人確認の書類の添付",
  "退職所得の受給に関する申告書の登録",
  "源泉徴収票の確認",
  "申告書兼退職所得申告書の作成",
  "退職所得情報登録",
  "登録内容の確認",
  "機構へ提出",
];

const contextText = `「請求者メールアドレス（機構連絡用）」が登録されていません。請求者様がメールアドレスを保有している場合は、必ず登録をしてください。<
登録いただくことで、手続きの進捗状況が請求者様にもご確認いただけます。<
なお、メールアドレスを保有していない場合は、共済契約者様から請求者様に進捗状況（請求時、審査結果、送金予定日）を遅滞なくお伝えいただくことが必要となります。<
手続きを続ける場合は、「次へ」ボタンを押してください。<
「請求者メールアドレス（機構連絡用）」を登録する場合は、「戻る」ボタンを押してください。`;

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "請求者氏名（ｶﾅ）",
    keyword: "demanderNameKana",
    type: "name",
    requiredIcon: true,
    helpicon: true,
    hafWidth: true,
    useFurigana: true,
    convertToHalfwidth: true,
    helpText: "請求者氏名のフリガナです。",
    showLine: true,
  },
  {
    title: "請求者氏名（全角漢字）",
    keyword: "demanderName",
    type: "name",
    requiredIcon: true,
    helpicon: true,
    helpText: (
      <>
        請求者氏名の漢字です。<br></br>
        なお、外国人については、フリガナ、漢字欄ともに「カタカナ」で入力をしてください。
      </>
    ),
    showLine: true,
  },
  {
    title: "請求者生年月日",
    keyword: "demanderBirth",
    type: "date",
    requiredIcon: true,
    helpicon: true,
    helpText: "請求者の生年月日です。",
    showLine: true,
  },
  {
    title: "請求者現住所（郵便番号）",
    keyword: "demanderZipcode",
    type: "addressSearch",
    requiredIcon: true,
    inputProps: { maxLength: 7 },
    helpicon: true,
    helpText: "請求者が現在お住まいの住所地の郵便番号を入力してください。",
    showLine: true,
  },
  {
    title: "請求者現住所",
    keyword: "locationGroup",
    type: "locationGroup",
    requiredIcon: true,
    inputProps: { maxLength: 85 },
    helpicon: true,
    helpText:
      "請求者が現在お住まいの住所地を入力してください（住民票の場所ではありません）。",
    showLine: true,
  },
  {
    title: "請求者連絡先電話番号",
    keyword: "tel",
    type: "phoneNum",
    requiredIcon: true,
    helpicon: true,
    helpText: "請求者の連絡先電話番号を入力してください。",
    showLine: true,
  },
  {
    title: "請求者メールアドレス（機構連絡用）",
    keyword: "demanderEmail",
    type: "mail",
    helpicon: true,
    helpText: "請求者の連絡先メールアドレスを入力してください。",
    showLine: true,
  },
  {
    title: "請求者メールアドレス（機構連絡用）（確認用）",
    keyword: "demanderEmailConfirm",
    type: "mail",
    showLine: true,
  },
  {
    title: "代行者連絡先メールアドレス",
    keyword: "agentEmail",
    type: "mail",
    requiredIcon: true,
    showLine: true,
  },
  {
    title: "代行者メールアドレス（確認用）",
    keyword: "agentEmailConfirm",
    type: "mail",
    requiredIcon: true,
    showLine: true,
  },
  {
    title: "退職理由",
    keyword: "retirementReason",
    type: "label",
    requiredIcon: false,
    helpicon: true,
    helpText:
      "退職理由（一身上の都合による退職、雇用期間満了による退職、結婚退職等）を入力してください。",
  },
];

const schema: any = {
  demanderBirth: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
  },
  demanderNameKana: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[ｧ-ﾝｦﾞﾟ\s-]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0054E"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "47"),
    },
  },
  demanderName: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "47"),
    },
  },
  demanderZipcode: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    maxLength: {
      value: 7,
      message: TkPropertyMessageGet("TKMSG_SCR0077E", "7"),
    },
    minLength: {
      value: 7,
      message: TkPropertyMessageGet("TKMSG_SCR0077E", "7"),
    },
  },
  locationGroup: {
    validate: (data: any) => {
      let error = {
        prefectures: "",
        city: "",
        address: "",
      };

      error = {
        prefectures: !data?.prefectures
          ? TkPropertyMessageGet("TKMSG_SCR0043E")
          : "",
        city: !data?.city
          ? TkPropertyMessageGet("TKMSG_SCR0043E")
          : data.city.length > 20
          ? TkPropertyMessageGet("TKMSG_SCR0046E", "20")
          : // eslint-disable-next-line no-control-regex
          !data.city.match(/^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]*$/)
          ? TkPropertyMessageGet("TKMSG_SCR0061E")
          : "",
        address: !data?.address
          ? TkPropertyMessageGet("TKMSG_SCR0043E")
          : data.address.length > 85
          ? TkPropertyMessageGet("TKMSG_SCR0046E", "85")
          : // eslint-disable-next-line no-control-regex
          !data.address.match(/^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]*$/)
          ? TkPropertyMessageGet("TKMSG_SCR0061E")
          : "",
      };

      if (
        error.prefectures !== "" ||
        error.city !== "" ||
        error.address !== ""
      ) {
        return JSON.stringify(error);
      }
    },
  },
  tel: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 19,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "19"),
    },
  },
  demanderEmail: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[a-zA-Z0-9_.-]+@([a-zA-Z0-9-]*\.)+[a-z]{2,}$/,
      message: TkPropertyMessageGet("TKMSG_SCR0062E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  demanderEmailConfirm: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[a-zA-Z0-9_.-]+@([a-zA-Z0-9-]*\.)+[a-z]{2,}$/,
      message: TkPropertyMessageGet("TKMSG_SCR0062E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  agentEmail: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[a-zA-Z0-9_.-]+@([a-zA-Z0-9-]*\.)+[a-z]{2,}$/,
      message: TkPropertyMessageGet("TKMSG_SCR0062E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  agentEmailConfirm: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[a-zA-Z0-9_.-]+@([a-zA-Z0-9-]*\.)+[a-z]{2,}$/,
      message: TkPropertyMessageGet("TKMSG_SCR0062E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  retirementReason: {
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
};

export { steps, contextText, fakeTableList, schema };
